import { RootState } from 'redux/reducers'

export const selectAppOnline = (state: RootState): boolean => state.appOnline.isOnline
